import Vue from 'vue'
import App from './App.vue'
import router from "./router/index"
import "bootstrap/dist/css/bootstrap.css";
import "./assets/sass/paper-dashboard.scss";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { initializeRouter } from "./helpers/general";
import VueParticles from 'vue-particles'
import VModal from "vue-js-modal";

Vue.use(VModal);
Vue.use(VueParticles)

// multiple lang
import i18n from './lang/Vuei18n'


// Vuelidate
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import moment from 'moment';
//  Filter
Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(value).utcOffset("+09:00").format('YYYY-MM-DD HH:mm');
    }
});
Vue.filter('formatCurrency', function(value, splitStr = ',') {
    if (value === null || value === undefined) {
        return '';
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, splitStr);
});
Vue.filter('percentage', function (value, decimals) {
    if (!value || value < 0) {
      value = 0
    }
  
    if (!decimals) {
      decimals = 0
    }
  
    value = value * 100
    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
    value = value + '%'
    return value
});

Vue.filter('formatFloat', function (value, decimals) {
    if (typeof value !== "number") {
        return value;
    }
    if (!decimals) {
        decimals = 0
    }
    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
    return value
});

library.add(faUserSecret);
Vue.component('font-awesome-icon', FontAwesomeIcon);

import { handleFormControlFocus } from "./plugins/paperDashboard/formControlFocusBorder";
Vue.config.productionTip = false;
initializeRouter(router);

new Vue({
    i18n,
    router,
    render: h => h(App),
}).$mount('#app');

handleFormControlFocus();